module.exports = __webpack_public_path__ + "img/image-gallery-placeholder-text.8ab4877e.png";